module.exports = __webpack_public_path__ + "static/media/menu1.7ee9033b.jpg";